import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import style from './gate.module.scss';
import TotemModal from './TotemModal/TotemModal';
import { Image } from 'antd';

const Gate = () => {
  const {
    container,
    perfumery,
    dermocosmetics,
    medicaments,
    conferences,
    fadeElement,
    glow,
    totem
  } = style;

  const [fadeState, setFadeState] = useState(null);
  const [totemModalOpen, setTotemModalOpen] = useState(false);
  const history = useHistory();

  const hall = `${process.env.REACT_APP_PUBLIC_ASSETS}/public/Hall.png`;

  const handleClick = (e, to) => {
    e.preventDefault();
    setFadeState(fadeElement);
    setTimeout(() => {
      history.push(`/${to}`);
      setFadeState(null);
    }, 610);
  };

  return (
    <>
      <div className={container + ' hall-container'}>
        <Image preview={false} alt="" src={hall} />
        <div className={fadeState}></div>

        <div 
          onClick={(e) => handleClick(e, 'medicaments')} 
          className={perfumery}
        >
          <div className={glow}></div>
          <div>
            <p>MEDICAMENTOS</p>
          </div>
        </div>

        <div
          onClick={(e) => handleClick(e, 'perfumery')}
          className={dermocosmetics}
        >
          <div>
            <div className={glow}></div>
            <p>PERFUMERÍA</p>
          </div>
        </div>

        <div
          onClick={(e) => handleClick(e, 'dermocosmetics')}
          className={medicaments}
        >
          <div>
            <div className={glow}></div>
            <p>DERMOCOSMÉTICA</p>
          </div>
        </div>

        <div
          onClick={(e) => handleClick(e, 'conferences')}
          className={conferences}
        >
          <div>
            <div className={glow}></div>
            <p>CONFERENCIAS</p>
          </div>
        </div>
        
        <div
          onClick={() => setTotemModalOpen(true)}
          className={totem}
        >
          <div>
            <div className={glow}></div>
            <p>Click<br/> aquí</p>
          </div>
        </div>
      </div>
      <TotemModal  set={setTotemModalOpen} state={totemModalOpen}/>
    </>
  );
};

export default Gate;
